/**
 * @file Selfie Swap Main Component.
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';
import get from 'lodash.get';

import SelfieSwapHeader from './SelfieSwapHeader';
import ContentWrap from '../../../../components/global/ContentWrap';
import Spinner from '../../../../components/global/Spinner';
import Alert from '../../../../components/global/Alert';
import CreateAccountIdentityContainer from '../../containers/CreateAccountIdentityContainer';
import UpdateAccountIdentityContainer from '../../containers/UpdateAccountIdentityContainer';
import {
  CREATE_ACCOUNT_IDENTITY_MODAL,
  UPDATE_ACCOUNT_IDENTITY_MODAL,
} from '../../constants/modals';
import SelfieSwapIdentityContainer from '../../containers/selfie-swap/SelfieSwapIdentityContainer';
import { getAsset } from '../../../../util/assets';

class SelfieSwap extends Component {
  static propTypes = {
    openModal: PropTypes.func.isRequired,
    identities: PropTypes.arrayOf(PropTypes.object),
    loading: PropTypes.bool,
    location: PropTypes.shape({
      search: PropTypes.string,
    }),
  };

  static defaultProps = {
    identities: [],
  };

  // We'll use this to open up the edit modal for an
  // specific identity if it comes from the query string
  identityFromQueryParsed = false;

  componentDidMount() {
    this.getIdentityFromQueryString();
  }

  componentDidUpdate() {
    this.getIdentityFromQueryString();
  }

  getIdentityFromQueryString = () => {
    const { location, loading, identities, openModal } = this.props;

    if (this.identityFromQueryParsed || loading) {
      return;
    }

    if (!get(location, 'search')) {
      this.identityFromQueryParsed = true; // Will avoid the search within componentDidUpdate
      return;
    }

    const { identityId } = qs.parse(location.search);

    if (identityId) {
      const identity = identities.find(
        identityItem => identityItem.id === identityId,
      );

      // Avoid repeating this process
      this.identityFromQueryParsed = true;

      if (!identity) {
        return;
      }

      openModal(UPDATE_ACCOUNT_IDENTITY_MODAL, {
        identity,
        outdatedSelfie: identity.has_outdated_selfie,
        forceSelfieUpdate: !identity.current_photo,
      });
    }
  };

  onAddFace = event => {
    event.preventDefault();
    const { openModal } = this.props;

    openModal(CREATE_ACCOUNT_IDENTITY_MODAL);
  };

  render() {
    const { identities, loading, openModal } = this.props;

    return (
      <Fragment>
        <SelfieSwapHeader openModal={openModal} />
        <div className="content-wrap-gray min-h-100vh flex-auto">
          <ContentWrap>
            <h3>Update Your Selfie</h3>
            <p>
              Welcome to the Waldo Selfie Hub. Please add or update your selfie.
            </p>

            {loading && <Spinner className="d-block mx-auto my-2" />}
            {!loading && (
              <div className="flex-list">
                {identities.length === 0 && (
                  <Alert type="info">
                    You have no faces yet. Get started by adding a new one.
                  </Alert>
                )}

                {identities.map(identity => (
                  <SelfieSwapIdentityContainer
                    key={identity.id}
                    identity={identity}
                  />
                ))}
                <div className="flex-list-item">
                  <button
                    onClick={this.onAddFace}
                    className="btn-add-new-identity btn-reset text-primary text-bold"
                    key="add-btn"
                  >
                    <img
                      src={getAsset('/icon-add-face.svg')}
                      alt=""
                      className="mr-2"
                      width="42"
                      height="42"
                    />
                    Add new Identity
                  </button>
                </div>
              </div>
            )}
          </ContentWrap>
        </div>

        <CreateAccountIdentityContainer requiresSelfieChecklistVerification />
        <UpdateAccountIdentityContainer requiresSelfieChecklistVerification />
      </Fragment>
    );
  }
}

export default SelfieSwap;
